import { useUserData } from 'app/main/components';
import { ViewPageListTab } from 'app/main/components/page-layouts';
import type { ViewPageContentTabProps, ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import MailsListItem from '../MailsListItem';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		content: props => <ViewPageListTab {...props} id="mailsView" itemLayout={MailsListItem} />
	}
];

export default tabs;
